<!-- App Profile -->
<jhi-page-ribbon></jhi-page-ribbon>

<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full items-center">
	<!-- Content -->
	<div class="flex flex-col flex-auto">
		<!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
		<ng-container *ngIf="state !== 'notFound'; else notFound">
			<router-outlet *ngIf="true"></router-outlet>
		</ng-container>
		<ng-template #notFound>
			<jhi-not-found class="flex h-full"></jhi-not-found>
		</ng-template>
	</div>
</div>
